var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"audio-waveform-container"},[_c('canvas',{ref:"waveformCanvas",staticClass:"waveform-canvas",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }